import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { FormGroup, FormControl, Validators} from "@angular/forms";
import { ErrorUtil } from "src/app/_utilities/error";
import { AssetService } from 'src/app/_services/asset.service';
import {UtilServiceService} from 'src/app/_services/utilService/util-service.service';
import moment from "moment-timezone";

@Component({
  selector: "app-configure-inspection",
  standalone: false,
  templateUrl: "./configure-inspection.component.html",
  styleUrl: "./configure-inspection.component.scss",
})
export class ConfigureInspectionComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  inspectionTypesForm: FormGroup;
  frequencyList: any = [
    {
      fName: "Daily",
      fVal: "DAILY",
      beVal: 1,
      frequencyType: "DAY",
    },
    {
      fName: "Weekly",
      fVal: "WEEKLY",
      beVal: 1,
      frequencyType: "WEEK",
    },
    {
      fName: "Fortnightly",
      fVal: "BIWEEKLY",
      beVal: 2,
      frequencyType: "WEEK",
    },
    {
      fName: "Monthly",
      fVal: "MONTHLY",
      beVal: 1,
      frequencyType: "MONTH",
    },
    {
      fName: "Every 3 Months",
      fVal: "3MONTHS",
      beVal: 3,
      frequencyType: "MONTH",
    },
    {
      fName: "Every 6 Months",
      fVal: "6MONTHS",
      beVal: 6,
      frequencyType: "MONTH",
    },
    {
      fName: "Annually",
      fVal: "ANNUALLY",
      beVal: 1,
      frequencyType: "YEAR",
    },
  ];
  linkedChecklist: any = [];

  dueDateOptions: any = [
    {
      name: "Completed Date",
      value: "COMPLETED_DATE",
    },
    {
      name: "Due Date",
      value: "DUE_DATE",
    },
  ];
  defaultDate = new Date();
  minDate = new Date(new Date().setHours(0, 0, 0, 0));//minimum selectable date is today
  data: any;
  assetTypeId: any;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private errorUtil: ErrorUtil,
    private assetServc: AssetService,
    private util: UtilServiceService,
    private bsModalServc: BsModalService,
  ) {
    super();
    this.inspectionTypesForm = new FormGroup({
      name: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/),
        Validators.maxLength(255)
      ]),
      frequency: new FormControl("", [Validators.required]),
      checklist: new FormControl("",  [Validators.required]),
      dueDateDerivation: new FormControl(null, [Validators.required]),
      startDate: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.getLanguageData();
    console.log(this.data, "data printing in ngOnInit");
    if (this.data.mode == "edit" && this.data.module == "assetType") {
      //format frequency text
      let idx: number = this.frequencyList.findIndex((f: any) => {
        return (
          f.beVal == this.data.data.frequency &&
          f.frequencyType == this.data.data.frequencyType
        );
      });
      this.inspectionTypesForm.patchValue({
        frequency: this.frequencyList[idx].fVal,
      });

      this.inspectionTypesForm.patchValue({
        name: this.data.data.name,
        //checklist: this.data.data.checklistId,
        startDate: this.util.formatISOStringToDate(this.data.data.startDate),
        dueDateDerivation: this.data.data.dueDateDerivation,
      });

      let sDateVal: any = this.util.formatISOStringToDate(this.data.data.startDate);
      if (sDateVal < this.minDate) {
        //update the minDate to be start date value
        this.minDate = new Date(sDateVal.setHours(0,0,0,0));
      }

    } else if (this.data.mode == "edit" && this.data.module == "asset") {
      //format frequency text
      let idx: number = this.frequencyList.findIndex((f: any) => {
        return (
          f.beVal == this.data.data.assetInspectionType.frequency &&
          f.frequencyType == this.data.data.assetInspectionType.frequencyType
        );
      });
      this.inspectionTypesForm.patchValue({
        frequency: this.frequencyList[idx].fVal,
      });

      this.inspectionTypesForm.patchValue({
        name: this.data.data.assetInspectionType.name,
        //checklist: this.data.data.checklistId,
        startDate: this.util.formatISOStringToDate(
          this.data.data.assetInspectionType.startDate,
        ),
        dueDateDerivation: this.data.data.assetInspectionType.dueDateDerivation,
      });

      let sDateVal: any = this.util.formatISOStringToDate(this.data.data.assetInspectionType.startDate);
      if (sDateVal < this.minDate) {
        //update the minDate to be start date value
        this.minDate = new Date(sDateVal.setHours(0,0,0,0));
      }

    } else {
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.getLinkedChecklists();
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  onCancelClick(): void {
    this.bsModalServc.setDismissReason("cancelled");
    this.modalRef.hide();
  }

  onInspectionAdd() {
    if (this.inspectionTypesForm.valid) {
      let configs: any = [];
      let frequencyVal: any = this.frequencyList.filter((f: any) => {
        return f.fVal === this.inspectionTypesForm.get("frequency")?.value;
      });
      let payload: any = {
        name: this.inspectionTypesForm.get("name")?.value,
        frequency: frequencyVal[0].beVal,
        frequencyType: frequencyVal[0].frequencyType,
        //checklist: { id: this.inspectionTypesForm.get("checklist")?.value },
        startDate: this.util.formatDateToISOString(
          this.inspectionTypesForm.get("startDate")?.value,
        ),
        dueDateDerivation:
          this.inspectionTypesForm.get("dueDateDerivation")?.value,
      };

      if ( this.inspectionTypesForm.get("checklist")?.value ){
        payload["checklist"] = { id: this.inspectionTypesForm.get("checklist")?.value };
      }

      if (this.data.mode == "create") {
        if (this.data.module == "asset") {
          payload.asset = {
            id: this.data.data, //asset id from certificate setting component when cert typ is in create mode
          };
        } else {
          payload["assetsType"] = {
            id: this.data.data, //asset type id from certificate setting component when cert typ is in create mode
          };
        }

        this.push(
          this.assetServc.createAssetInspectionType(payload).subscribe({
            next: (res: any) => {
              console.log(res, "response printing..");
              if (res.status == 200 || res.status == 201) {
                this.errorUtil.setErrorMessage(
                  200,
                  "Inspection Type has been added successfully",
                  null,
                  "success",
                  5000,
                );

                let jsonObj: any = {
                  reason: "inspect-type-added",
                };
                this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
                this.modalRef.hide();
              }
            },
            error: (err: any) => {
              console.log(err, "error in POST asset inspection");
              this.errorUtil.setErrorMessage(
                err.status,
                err.error ? err.error.title : null,
                err.error ? err.error.title : null,
                "error",
                2000,
              );
            },
          }),
        );
      } else {
        if (this.data.module == "asset") {
          payload.asset = {
            id: this.data.data.assetId, //asset id from certificate setting component when cert type is in edit mode
          };
          payload["id"] = this.data.data.assetInspectionType.id;
        } else {
          payload["assetsType"] = {
            id: this.data.data.assetTypeId, //asset type id from certificate setting component when cert type is in edit mode
          };
          payload["id"] = this.data.data.id;
        }

        //update api call // updateAssetInspectionType

        this.push(
          this.assetServc.updateAssetInspectionType(payload).subscribe({
            next: (res: any) => {
              console.log(res, "response printing..");
              if (res.status == 200 || res.status == 201) {
                this.errorUtil.setErrorMessage(
                  200,
                  "Inspection Type has been updated successfully",
                  null,
                  "success",
                  5000,
                );

                let jsonObj: any = {
                  reason: "inspect-type-updated",
                };
                this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
                this.modalRef.hide();
              }
            },
            error: (err: any) => {
              console.log(err, "error in PUT asset inspection");
              this.errorUtil.setErrorMessage(
                err.status,
                err.error ? err.error.title : null,
                err.error ? err.error.title : null,
                "error",
                2000,
              );
            },
          }),
        );
      }
    }
  }

  getLinkedChecklists() {
    if (this.data.mode == "create") {
      this.assetTypeId = this.data.data;
    } else {
      this.assetTypeId = this.data.data.assetTypeId;
    }

    if (this.data.module == "assetType") {
      this.push(
        this.assetServc.getChecklistByAssetTypeId(this.assetTypeId).subscribe({
          next: (res: any) => {
            this.linkedChecklist = res.body;
            if (this.data.mode == "edit") {
              this.inspectionTypesForm.patchValue({
                checklist: this.data.data.checklistId,
              });
            }
          },
          error: (err: any) => {
            console.log(err, "err from get checklist api");
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        }),
      );
    } else {
      if (this.data.mode == "edit") {
        this.assetTypeId = this.data.data.assetId;
      }
      this.push(
        this.assetServc.getChecklistByAssetId(this.assetTypeId).subscribe({
          next: (res: any) => {
            this.linkedChecklist = res.body;
            if (this.data.mode == "edit") {
              this.inspectionTypesForm.patchValue({
                checklist: this.data.data.checklistId,
              });
            }
          },
          error: (err: any) => {
            console.log(err, "err from get checklist api");
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        }),
      );
    }
  }
}
